<template>
  <div class="modal-prefectures">
    <!-- ラベル -->
    <div class="modal-prefectures__label" ref="select_label">
      <!-- button -->
      <div class="modal-prefectures__wrap --button">
        <button
          :title="currentLabel"
          class="modal-prefectures__button --pseudo-input"
          :class="{
            'is-focused': isModalActive,
            'is-inputed': currentSelectLargeLabel !== '',
            'is-error': isError,
            'is-deep-color': isDeepPlaceHoldColor,
          }"
          @click="swtichModal(true)"
        >
          {{ getLabel() }}
        </button>
        <!-- arrow icon -->
        <IconArrow :isFocus="isModalActive" />
      </div>
    </div>

    <!-- 一覧 -->
    <div v-if="isModalActive" class="modal-prefectures__wrap --modal">
      <div
        class="modal-prefectures__modal"
        :class="{
          'is-hidden-label': !isLabelDisplay,
          'is-fixed-width': isFixedWidth,
        }"
      >
        <div class="modal-prefectures__heading">
          <span>{{ labelText }}を選択してください</span>
          <button
            class="modal-prefectures__button --close"
            @click="setParameters"
          ></button>
        </div>

        <ul class="modal-prefectures__list --large" ref="list_large">
          <li
            v-for="large in getList"
            :key="`large-list-${large.id}`"
            class="modal-prefectures__item --large"
            :class="setButtonState(large.id, currentSelectLargeId)"
          >
            <button
              ref="button_medium"
              class="modal-prefectures__button --large"
              :class="setButtonState(large.id, currentSelectLargeId)"
              @click="setCurrentSelectLarge(large)"
            >
              {{ large.label }}
            </button>
            <div
              class="modal-prefectures__wrap --list"
              :class="{ 'is-active': large.id === currentSelectLargeId }"
            >
              <ul class="modal-prefectures__list --medium">
                <li
                  v-for="medium in large.target"
                  :key="`medium-list-${medium.id}`"
                  class="modal-prefectures__item --medium"
                  :class="{
                    'has-small-category': medium.target,
                    'is-active': currentSelectMediumId.includes(medium.id),
                  }"
                >
                  <button
                    class="modal-prefectures__button --medium"
                    :class="setButtonState(medium.id, currentSelectMediumId, 'medium')"
                    @click="setCurrentSelectMedium(medium)"
                  >
                    {{ medium.label }}
                  </button>
                  <div
                    class="modal-prefectures__wrap --list --small"
                    :class="{
                      'is-active': currentSelectMediumId.includes(medium.id),
                    }"
                  >
                    <ul class="modal-prefectures__list --small">
                      <li
                        v-for="small in medium.target"
                        :key="`small-list-${small.id}`"
                        class="modal-prefectures__item --small"
                      >
                        <button
                          class="modal-prefectures__button --small"
                          :class="
                            setButtonState(
                              small.id,
                              currentSelectSmallId,
                              'small',
                            )
                          "
                          @click="setCurrentSelectSmall(small)"
                        >
                          {{ small.label }}
                        </button>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="modal-prefectures__buttons">
          <button
            class="modal-prefectures__button --reset"
            @click="resetCurrentSelect('all')"
          >
            リセット
          </button>
          <button
            class="modal-prefectures__button --dicision"
            @click="setParameters"
          >
            決定
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="isModalActive"
      class="modal-prefectures__background"
      @click="setParameters"
    ></div>
  </div>
</template>

<script>
import PrefecturesList from '../prefecturesList.json'
import IconArrow from '@/components/elements/AppIconArrow/'

export default {
  name: 'SelectModal',
  components: {
    IconArrow
  },
  data() {
    return {
      isModalActive: false,          // 選択画面が表示されているか

      currentSelectRegionId: '',     // 地方情報を代入（region-1, region-2...）

      currentSelectLargeId: '',      // 現在選択されている大カテゴリ (hokkaido, aomori...)
      currentSelectMediumId: '',     // 現在選択されている中カテゴリ (sapporo, jozankei...)
      currentSelectSmallId: '',      // 現在選択されている小カテゴリ (上からA, B, C...)

      currentSelectLargeLabel: '',   // 現在選択されている大カテゴリの文字列
      currentSelectMediumLabel: '',  // 現在選択されている中カテゴリの文字列
      currentSelectSmallLabel: '',   // 現在選択されている小カテゴリの文字列

      currentQueryLargeList: {},     // 現在クエリに設定されている大カテゴリ情報
      currentQueryMediumList: {},    // 現在クエリに設定されている中カテゴリ情報
      currentQuerySmallList: {},     // 現在クエリに設定されている小カテゴリ情報

      fullLabelList: {
        large: [],
        medium: [],
        small: [],
        forSearchHistory: [],
      },                             // 検索履歴用

      lastClickedLargeRefIndex: -1,  // 最後にクリックされた大カテゴリのref_index
      lastClickedMediumRefIndex: -1, // 最後にクリックされた中カテゴリのref_index
      
      currentSelectMediumList: [],   // 中カテゴリの複数選択が許可されている際に、選択された小カテゴリ情報を格納
      currentSelectSmallList: [],    // 小カテゴリの複数選択が許可されている際に、選択された小カテゴリ情報を格納

      buttonHeight: 48,              // モーダル内のボタンの高さ。以下のスクロール量計算に使用
      scrollPoint: 0,                // クリックされたボタンをモーダル内のトップにスクロールさせるためのスクロール量

      currentLabel: '',              // 現在選択されている条件から生成されたカテゴリの文字列

      windowWidth: 0,                // resizeイベントで代入されるウィンドウ幅
    }
  },
  props: {
    // エラー状態か
    isError: {
      type: Boolean,
      required: false,
      default: false
    },
    // プレースホールドに表示したいテキスト
    placeHoldText: {
      type: String,
      required: false,
      default: ''
    },
    // プレースホールドの色を標準で濃くするか
    isDeepPlaceHoldColor: {
      type: Boolean,
      required: false,
      default: false
    },
    // input左側、モーダル内ヘッダーに表示するラベル
    labelText: {
      type: String,
      required: false,
      default: ''
    },
    // input左側に表示されるラベルの表示状態
    isLabelDisplay: {
      type: Boolean,
      required: false,
      default: true
    },
    // モーダル幅を固定で表示したい
    isFixedWidth: {
      type: Boolean,
      required: false,
      default: false
    },
    // smallの複数選択の許可
    isMultipleSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    // ラベルがクリックされたら任意の位置までスクロールさせる、そのスクロール量
    scrollPointToLabel: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    /**
     * リストを返却
     */
    getList() {
      return PrefecturesList
    },
  },
  watch: {
    /**
     * モーダルの開閉状態に応じて処理
     */
    isModalActive() {
      if (this.isModalActive) {
        this.scrollListInModal()
        return
      }
      this.scrollPoint = 0
    },
  },
  created() {
    // 複数選択モードの場合は中・小カテゴリが複数選択対象となるため、その前処理
    if (
      this.isMultipleSelect &&
      this.currentSelectSmallId === '' &&
      this.currentSelectSmallLabel === '' &&
      this.currentSelectMediumId &&
      this.currentSelectMediumLabel
    ) {
      this.currentSelectSmallId = []
      this.currentSelectSmallLabel = []
      this.currentSelectMediumId = []
      this.currentSelectMediumLabel = []
    }

    // escapeキー押下でモーダルを閉じる
    window.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.isModalActive = false
      }
    })

    // クエリパラメータから状態を反映
    this.setDataFromQuery()
  },
  mounted() {
    this.setWindowWidth()
    this.setParameters()
    this.setScrollPoint()
  },
  methods: {
    /**
     * 画面幅を設定
     */
    setWindowWidth() {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    },
    /**
     * created時、クエリパラメータから初期値を設定
     */
    setDataFromQuery() {
      const query = this.$route.query
      // 各変数に、クエリパラメータの都道府県・市区町村・エリアを代入
      // hokkaido, sapporo, A,B 等
      const [largeId, mediumId, smallId] = [
        query.areaMidClassCd || "",
        query.areaSmlClassCd || "",
        query.areaDtlClassCd || "",
      ]

      // 地域を登録（東北・関東等）
      this.currentSelectRegionId = query.areaLrgClassCd

      // queryに都道府県が存在していたら
      if (largeId !== "") {
        this.currentQueryLargeList = this.getList.filter(d => d.id === largeId)[0]
        this.currentSelectLargeId = largeId
        this.currentSelectLargeLabel = this.currentQueryLargeList.label
        this.fullLabelList.large = this.currentQueryLargeList.label
      }

      // queryに市区町村が存在していたら
      if (mediumId !== "") {
        this.currentSelectMediumId = mediumId

        // 複数選択されている場合（= カンマで区切られている）
        if (mediumId.includes(',')) {
          const mediumList = mediumId.split(',')

          this.currentQueryMediumList = []
          mediumList.forEach((d, i) => {
            this.currentQueryMediumList[i] = this.currentQueryLargeList.target.filter(e => e.id === d)[0]
          })
          // 「hoge、fuga」という文字列を生成して代入
          this.currentSelectMediumLabel = this.currentQueryMediumList.map(d => d.label).join('、')
        }
        // 複数選択されていない場合
        else {
          this.currentQueryMediumList = this.currentQueryLargeList.target.filter(d => d.id === mediumId)
          this.currentSelectMediumLabel = this.currentQueryMediumList[0].label
        }

        this.fullLabelList.medium = this.currentQueryMediumList.map(d => {
          return {
            label: d.label,
            full_label: d.full_label
          }
        })
      } else {
        this.currentQueryMediumList = []
      }

      // queryにエリアが存在していたら
      if (smallId !== "") {
        this.currentSelectSmallId = smallId

        // 複数選択されている場合（= カンマで区切られている）
        if (smallId.includes(',')) {
          const smallList = smallId.split(',')
          this.currentQuerySmallList = []
          const _currentQueryMedium = [this.currentQueryMediumList].flat()
          smallList.forEach((d, i) => {
            this.currentQuerySmallList[i] = _currentQueryMedium[0].target.filter(e => e.id === d)[0]
          })
          // 「hoge、fuga」という文字列を生成して代入
          this.currentSelectSmallLabel = this.currentQuerySmallList.map(d => d.label).join('、')
        }
        // 複数選択されていない場合
        else {
          this.currentQuerySmallList = this.currentQueryMediumList[0].target.filter(d => d.id === smallId)
          this.currentSelectSmallLabel = this.currentQuerySmallList
            ? this.currentQuerySmallList[0].label
            : ""
        }

        this.fullLabelList.small = this.currentQuerySmallList.map(d => {
          return {
            label: d.label,
            full_label: d.full_label
          }
        })
      } else {
        this.currentQuerySmallList = []
      }

      this.currentSelectMediumList = this.currentQueryMediumList
      this.currentSelectSmallList = this.currentQuerySmallList
      this.initFullLabelList()
    },
    /**
     * 選択モーダルの表示切替
     * @param {boolean} bool 
     */
    swtichModal(bool) {
      this.isModalActive = bool
      if (this.scrollPointToLabel > 0) {
        this.onScrollLabel()
      }
    },
    /**
     * v-forから取得したidと、現在設定されているidを比較して
     * 適切なclassを返却する
     */
    setButtonState(id, currentId, type) {
      if (this.isMultipleSelect && (type === 'small' || type === 'medium')) {
        return currentId.includes(id)
          ? 'is-active'
          : ''
      }

      return id === currentId
        ? 'is-active'
        : ''
    },
    /**
     * inputがクリックされ、モーダルが開いた際に
     * 選択しやすいようにページをスクロールさせる
     */
    onScrollLabel() {
      const isMobileSize = this.windowWidth < 640
      if (isMobileSize) return

      if (this.isModalActive) {
        const label = this.$refs.select_label
        const top = label.getBoundingClientRect().top
        const currentScroll = window.scrollY
        const margin = this.scrollPointToLabel // ページ上部からどれだけ離して表示させるかの数値

        window.scrollTo({
          top: top + currentScroll - margin,
          behavior: "smooth",
        })
      }
    },
    /**
     * クリックされているエリア情報から、モーダル内でスクロールする量を計算する
     */
    setScrollPoint() {
      // モーダル内でリセットが押され、何も選択されていない場合はスクロール量を0に戻して終了
      const [isUnsetLargeId, isUnsetMediumId] = [
        this.currentSelectLargeId === '',
        this.currentSelectMediumId === '',
      ]

      if (isUnsetLargeId && isUnsetMediumId) {
        this.scrollPoint = 0
        return
      }

      // リロードして、最後にクリックされた情報がリセットされた場合は
      // クエリパラメータから現在選択されている情報を取得し、スクロール量を算出する

      // 複数選択が許可されている場合は大カテゴリのみ参照
      if (this.isMultipleSelect) {
        const isUnsetLargeIndex = this.lastClickedLargeRefIndex === -1

        if (isUnsetLargeIndex) {
          this.lastClickedLargeRefIndex = this.currentQueryLargeList.ref_index
        }

        const large = this.lastClickedLargeRefIndex > -1 ? this.lastClickedLargeRefIndex : 0
        this.scrollPoint = large * this.buttonHeight
      }
      // 複数選択が許可されていない場合は大中カテゴリを参照
      else {
        const [isUnsetLargeIndex, isUnsetMediumIndex] = [
          this.lastClickedLargeRefIndex === -1,
          this.lastClickedMediumRefIndex === -1,
        ]

        if (isUnsetLargeIndex && isUnsetMediumIndex) {
          this.lastClickedLargeRefIndex = this.currentQueryLargeList.ref_index
          this.lastClickedMediumRefIndex = this.currentQueryMediumList.ref_index + 1
        }

        const [large, medium] = [
          this.lastClickedLargeRefIndex > -1 ? this.lastClickedLargeRefIndex : 0,
          this.lastClickedMediumRefIndex > -1 ? this.lastClickedMediumRefIndex : 0,
        ]

        this.scrollPoint = (large + medium) * this.buttonHeight
      }
    },
    /**
     * クリックされたらモーダル内でトップへスクロールさせる
     */
    scrollListInModal() {
      this.setScrollPoint()

      setTimeout(() => {
        this.largeList = this.$refs.list_large
        this.largeList.scrollTo({
          top: this.scrollPoint,
          behavior: "smooth"
        })
      }, 50)
    },
    /**
     * large情報を設定する
     * @param {object} large 
     */
    setCurrentSelectLarge(large) {
      this.resetCurrentSelect('large')
      if (this.currentSelectLargeId === large.id) {
        this.currentSelectLargeId = ''
        this.currentSelectLargeLabel = ''
        this.lastClickedLargeRefIndex = -1
        this.currentSelectRegionId = ''
        this.scrollListInModal()
        return
      }

      this.currentSelectRegionId = large.region
      this.currentSelectLargeId = large.id
      this.currentSelectLargeLabel = large.label
      this.lastClickedLargeRefIndex = large.ref_index
      this.scrollListInModal()
    },
    /**
     * medium情報を設定する
     * @param {object} medium
     */
    setCurrentSelectMedium(medium) {
      if (this.currentSelectMediumId === medium.id && !this.isMultipleSelect) {
        this.resetCurrentSelect('medium')
        this.currentSelectMediumId = ''
        this.currentSelectMediumLabel = ''
        this.lastClickedMediumRefIndex = -1
        this.scrollListInModal()
        return
      }

      // selectsmallからコピペ
      // エリアが複数選択の場合
      if (this.isMultipleSelect) {
        // チェック済みの市区町村をクリックして、もしその市区町村がエリアを持っていたら
        // エリアの選択を解除する
        if (this.currentSelectMediumId.includes(medium.id) && medium.target) {
          this.resetCurrentSelect('medium')
        }

        if (this.currentSelectMediumList.some(d => d.id === medium.id)) {
          this.currentSelectMediumList = this.currentSelectMediumList.filter(d => d.id !== medium.id)
        } else {
          this.currentSelectMediumList.push(medium)
        }
        this.currentSelectMediumList.sort((a, b) => a.ref_index > b.ref_index ? 1 : -1)
        this.currentSelectMediumId = this.currentSelectMediumList.map(d => d.id)
        this.currentSelectMediumLabel = this.currentSelectMediumList.map(d => d.label)
        this.lastClickedMediumRefIndex = medium.ref_index + 1
        
        const checkedMedium = this.currentSelectMediumList.map(d => d.id).includes(medium.id)
        if (checkedMedium && medium?.target) {
          this.currentSelectSmallId = []
          this.currentSelectSmallLabel = []
          this.currentSelectSmallList = []
        }
      }
      // エリアが単一選択の場合
      else {
        this.currentSelectMediumId = medium.id
        this.currentSelectMediumLabel = medium.label
        this.lastClickedMediumRefIndex = medium.ref_index + 1
        this.scrollListInModal()
      }
    },
    /**
     * small情報を設定する
     * @param {object} small
     */
    setCurrentSelectSmall(small) {
      if (this.currentSelectSmallId === small.id && !this.isMultipleSelect) {
        this.currentSelectSmallId = ''
        this.currentSelectSmallLabel = ''
        return
      }

      // エリアが複数選択の場合
      if (this.isMultipleSelect) {
        if (this.currentSelectSmallList.some(d => d.id === small.id)) {
          this.currentSelectSmallList = this.currentSelectSmallList.filter(d => d.id !== small.id)
        } else {
          this.currentSelectSmallList.push(small)
        }
        this.currentSelectSmallList.sort((a, b) => a.id > b.id ? 1 : -1)
        this.currentSelectSmallId = this.currentSelectSmallList.map(d => d.id)
        this.currentSelectSmallLabel = this.currentSelectSmallList.map(d => d.label)
      }
      // エリアが単一選択の場合
      else {
        this.currentSelectSmallId = small.id
        this.currentSelectSmallLabel = small.label
      }
    },
    /**
     * created時、現在設定されているエリア情報から検索履歴用のラベルを初期化
     */
    initFullLabelList() {
      // エリアまで選択されていたら、エリアを持つ市区町村は除いて市区町村・エリアを返す
      // エリアを持つ市区町村は常に先頭にあるため[0]を削除する
      if (this.fullLabelList.small.length > 0) {
        this.fullLabelList.medium = this.fullLabelList.medium.filter((_, i) => i !== 0)
        this.fullLabelList.forSearchHistory = [...this.fullLabelList.medium.map(d => d.full_label), ...this.fullLabelList.small.map(d => d.full_label)]
        return
      }

      // 市区町村まで選択されていたら、市区町村のみを返す
      if (this.fullLabelList.small.length === 0) {
        this.fullLabelList.forSearchHistory = [...this.fullLabelList.medium.map(d => d.full_label)]
        return
      }

      // 市区町村・エリア共に未設定の場合は都道府県のみ返す
      if (this.fullLabelList.medium.length === 0 && this.fullLabelList.small.length === 0) {
        this.fullLabelList.forSearchHistory = [this.fullLabelList.large]
        return
      }
    },
    /**
     * 検索履歴用のラベル用文字列を設定
     */
    setFullLabelList() {
      this.fullLabelList.large = this.currentSelectLargeLabel !== ""
        ? [this.currentSelectLargeLabel]
        : []
      
      this.fullLabelList.medium = this.currentSelectMediumList.length > 0
        ? this.currentSelectMediumList.map(d => 
          {
            return {
              label: d.label,
              full_label: d.full_label
            }
          }
        )
        : []

      this.fullLabelList.small = this.currentSelectSmallList.length > 0
        ? this.currentSelectSmallList.map(d => 
          {
            return {
              label: d.label,
              full_label: d.full_label
            }
          }
        )
        : []

      const [hasLarge, hasMedium, hasSmall] = [
        this.fullLabelList.large.length > 0,
        this.fullLabelList.medium.length > 0,
        this.fullLabelList.small.length > 0
      ]

      // エリアまで選択されている場合
      if (hasLarge && hasMedium && hasSmall) {
        this.fullLabelList.medium = this.fullLabelList.medium.filter((_, i) => i !== 0)
        this.fullLabelList.forSearchHistory = [...this.fullLabelList.small.map(d => d.full_label), ...this.fullLabelList.medium.map(d => d.full_label)]
      }

      // 市区町村まで選択されている場合
      if (hasLarge && hasMedium && !hasSmall) {
        this.fullLabelList.forSearchHistory = [...this.fullLabelList.medium.map(d => d.full_label)]
      }

      // 都道府県のみ選択されている場合
      if (hasLarge && !hasMedium && !hasSmall) {
        this.fullLabelList.forSearchHistory = [...this.fullLabelList.large]
      }

      // 何も選択されていない場合
      if (!hasLarge && !hasMedium && !hasSmall) {
        this.fullLabelList.forSearchHistory = []
      }
    },
    /**
     * キャンセルが押下されたら選択された各情報をリセットする
     * @param {type} string
     */
    resetCurrentSelect(type) {
      // 検索履歴用の情報をリセット
      this.fullLabelList = {
        large: [],
        medium: [],
        small: [],
        forSearchHistory: [],
      }

      this.currentSelectSmallId = ''
      this.currentSelectSmallLabel = ''
      this.currentSelectSmallList = []
      if (type === 'medium') return

      this.currentSelectMediumId = ''
      this.currentSelectMediumLabel = ''
      this.lastClickedMediumRefIndex = -1
      this.currentSelectMediumList = []
      if (type === 'large') return

      this.currentSelectRegionId = ''
      this.currentSelectLargeId = ''
      this.currentSelectLargeLabel = ''
      this.lastClickedLargeRefIndex = -1
      this.scrollListInModal()
    },
    /**
     * カテゴリの文字列を返却
     * 設定されていない場合は選択を促す文字列を返却
     */
    getLabel() {
      const [labelLarge, labelMedium, labelSmall] = [
        this.currentSelectLargeLabel,
        typeof this.currentSelectMediumLabel === 'string' && this.currentSelectMediumLabel !== ''
          ? this.currentSelectMediumLabel.split('、')
          : this.currentSelectMediumLabel,
        typeof this.currentSelectSmallLabel === 'string' && this.currentSelectSmallLabel !== ''
          ? this.currentSelectSmallLabel.split('、')
          : this.currentSelectSmallLabel,
      ]

      // 都道府県が選択されているか
      const hasLarge = labelLarge !== ''

      // 市区町村が選択されているか
      const hasMedium = labelMedium.length > 0

      // 市区町村が複数選択されているか
      const hasMultipleMedium = labelMedium.length > 1

      // エリアが選択されているか
      const hasSmall = labelSmall.length > 0
        
      // 都道府県が選択されていない（＝宿泊地未選択の場合）
      if (!hasLarge) {
        return this.placeHoldText
      }

      // 都道府県・市区町村・エリア情報をラベル用として一時的に格納する空配列
      const labelAll = {
        large: "",
        medium: [],
        small: [],
      }
      
      // 都道府県が選択されていたらラベル用文字列へ代入
      if (hasLarge) labelAll.large = labelLarge

      // 市区町村が選択されていたらラベル用配列へ追加
      if (hasMedium) labelAll.medium = labelMedium

      // エリアが選択されていたらラベル用配列へ追加
      if (hasSmall) labelAll.small = labelSmall

      // 市区町村が複数選択で、エリアが選択されている場合
      if (hasMultipleMedium && hasSmall) {
        labelAll.medium = labelAll.medium.filter((_, i) => i !== 0)
        this.currentLabel = labelAll.large + ' / ' + labelAll.small.join('、') + '、' + labelAll.medium.join('、')
      }

      // 市区町村が単一で、エリアが選択されている場合
      if (!hasMultipleMedium && hasMedium && hasSmall) {
        this.currentLabel = labelAll.large + ' / ' + labelAll.medium + ' / ' + labelAll.small.join('、')
      }

      // 市区町村が選択され、エリアが選択されていない場合
      if (hasMedium && !hasSmall) {
        this.currentLabel = labelAll.large + ' / ' + labelAll.medium.join('、')
      }

      // 都道府県のみ選択されている場合 
      if (hasLarge && !hasMedium) {
        this.currentLabel = labelAll.large
      }

      return this.currentLabel === ''
        ? this.placeHoldText
        : this.currentLabel
      
      // const [large, medium, small] = [
      //   String(this.currentSelectLargeLabel),
      //   typeof this.currentSelectMediumLabel !== 'string'
      //     ? this.currentSelectMediumLabel.join('、')
      //     : this.currentSelectMediumLabel,
      //   typeof this.currentSelectSmallLabel !== 'string'
      //     ? this.currentSelectSmallLabel.join('、')
      //     : this.currentSelectSmallLabel,
      // ]

      // const formatText = str => (str !== '' ? ` / ${str}` : '')

      // if (this.isMultipleSelect && this.currentSelectMediumList.length > 1) {
      //   this.currentLabel = large === ''
      //     ? ''
      //     : large + formatText(medium)
      // } else {
      //   this.currentLabel = large === ''
      //     ? ''
      //     : large + formatText(medium) + formatText(small)
      // }

      // return this.currentLabel === ''
      //   ? this.placeHoldText
      //   : this.currentLabel
    },
    /**
     * 現在の設定をemitし、ラベルを生成する
     */
    setParameters() {
      // 検索履歴用のラベルを生成
      this.setFullLabelList()

      // string型でなければ、指定した文字列で連結して返す
      const convertToString = (target, type = ',') => {
        return typeof target !== 'string'
          ? target.join(type)
          : target
      }

      // 選択された検索条件
      const parameters = {
        region_id: this.currentSelectRegionId,
        large_id: this.currentSelectLargeId,
        large_label: this.currentSelectLargeLabel,
        medium_id: convertToString(this.currentSelectMediumId),
        medium_label: convertToString(this.currentSelectMediumLabel, '、'),
        small_id: convertToString(this.currentSelectSmallId),
        small_label: convertToString(this.currentSelectSmallLabel, '、'),
        category_label: this.currentLabel,
        for_search_history: this.fullLabelList.forSearchHistory
      }

      this.$emit('inputed', parameters)
      this.swtichModal(false)
    }
  }
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
